const baseStyle = () => ({
  padding: 4,
  borderRadius: 'sm',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  space: 2,

  _description: {
    fontSize: 'md',
    lineHeight: 'md',
  },
  _icon: {
    size: 6,
    minWidth: 6,
    color: 'gray.900',
  },
  _title: {
    fontSize: 'md',
    lineHeight: 'md',
    fontWeight: '600',
  },
});

const variants = {
  info: {
    bg: 'blue.50',
    _button: {
      colorScheme: 'info',
    },
    _buttonHover: {
      bg: 'info.100',
    },
  },
  success: {
    bg: 'success.50',
    _button: {
      colorScheme: 'success',
    },
    _buttonHover: {
      bg: 'success.100',
    },
  },
  warning: {
    bg: 'warning.50',
    _button: {
      colorScheme: 'warning',
    },
    _buttonHover: {
      bg: 'warning.100',
    },
  },
  error: {
    bg: 'error.50',
    _button: {
      colorScheme: 'error',
    },
    _buttonHover: {
      bg: 'error.100',
    },
  },
};

const defaultProps = {
  variant: 'info',
};

export default {
  baseStyle,
  defaultProps,
  variants,
};
